export const SEO_CONFIG = {
  home: {
    title: "עו״ד ארז עזרא משרד עורכי דין | נזקי גוף | פתח תקווה",

    description:
      "עו״ד ארז עזרא – משרד עורכי דין לנזקי גוף בפתח תקווה. ייצוג בתאונות דרכים, ביטוח לאומי ורשלנות רפואית. ייעוץ ראשוני ללא התחייבות.",

    canonical: "https://ezlawyer.co.il/",
    robots: "index, follow",

    hreflang: [
      { lang: "he", href: "https://ezlawyer.co.il/" },
      { lang: "x-default", href: "https://ezlawyer.co.il/" },
    ],

    og: {
      title: "עו״ד ארז עזרא משרד עורכי דין | נזקי גוף | פתח תקווה",
      description:
        "עו״ד ארז עזרא – משרד עורכי דין לנזקי גוף בפתח תקווה. ייצוג בתאונות דרכים, ביטוח לאומי ורשלנות רפואית.",
      url: "https://ezlawyer.co.il/",
      type: "website",
      siteName: "עו״ד ארז עזרא",
      locale: "he_IL",
      image: "https://ezlawyer.co.il/og-image.jpg",
      imageType: "image/jpeg",
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "עו״ד ארז עזרא – משרד עורכי דין לנזקי גוף בפתח תקווה",
    },

    twitter: {
      card: "summary_large_image",
      title: "עו״ד ארז עזרא משרד עורכי דין | נזקי גוף | פתח תקווה",
      description: "ייצוג משפטי מקצועי בתחום נזקי גוף וביטוח לאומי.",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },
  },

  accessibility: {
    title: "הצהרת נגישות | עו״ד ארז עזרא",
    description: "הצהרת הנגישות של אתר עו״ד ארז עזרא.",
    canonical: "https://ezlawyer.co.il/accessibility",
    robots: "noindex, follow",

    og: {
      title: "הצהרת נגישות | עו״ד ארז עזרא",
      description: "הצהרת הנגישות של אתר עו״ד ארז עזרא.",
      url: "https://ezlawyer.co.il/accessibility",
      type: "article",
      siteName: "עו״ד ארז עזרא",
      locale: "he_IL",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },

    twitter: {
      card: "summary_large_image",
      title: "הצהרת נגישות | עו״ד ארז עזרא",
      description: "הצהרת הנגישות של אתר עו״ד ארז עזרא.",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },
  },

  privacy: {
    title: "מדיניות פרטיות | עו״ד ארז עזרא",
    description: "מדיניות הפרטיות של אתר עו״ד ארז עזרא.",
    canonical: "https://ezlawyer.co.il/privacy",
    robots: "noindex, follow",

    og: {
      title: "מדיניות פרטיות | עו״ד ארז עזרא",
      description: "מדיניות הפרטיות של אתר עו״ד ארז עזרא.",
      url: "https://ezlawyer.co.il/privacy",
      type: "article",
      siteName: "עו״ד ארז עזרא",
      locale: "he_IL",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },

    twitter: {
      card: "summary_large_image",
      title: "מדיניות פרטיות | עו״ד ארז עזרא",
      description: "מדיניות הפרטיות של אתר עו״ד ארז עזרא.",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },
  },

  terms: {
    title: "תנאי שימוש | עו״ד ארז עזרא",
    description: "תנאי השימוש של אתר עו״ד ארז עזרא.",
    canonical: "https://ezlawyer.co.il/terms",
    robots: "noindex, follow",

    og: {
      title: "תנאי שימוש | עו״ד ארז עזרא",
      description: "תנאי השימוש של אתר עו״ד ארז עזרא.",
      url: "https://ezlawyer.co.il/terms",
      type: "article",
      siteName: "עו״ד ארז עזרא",
      locale: "he_IL",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },

    twitter: {
      card: "summary_large_image",
      title: "תנאי שימוש | עו״ד ארז עזרא",
      description: "תנאי השימוש של אתר עו״ד ארז עזרא.",
      image: "https://ezlawyer.co.il/og-image.jpg",
    },
  },
};
